module.exports = __webpack_public_path__ + "img/shopeefood.8e0b07dd.jpeg";